import { DocumentDualHorizontalReceiptEntity, DocumentDualVerticalReceiptEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import { convertDualReceiptCsv } from '../Receipt/DualReceipt/convertDualReceiptCsv';
import { createFormDataToEntity } from '../Receipt/DualReceipt/createFormDataToEntity';
import { DualReceiptFormComponent } from '../Receipt/DualReceipt/DualReceiptFormComponent';
import { expandDualReceiptTable } from '../Receipt/DualReceipt/expandDualReceiptTable';
import { DocumentDualReceiptEntity } from '../Receipt/DualReceipt/types';
import { OcrResultPageDefinition } from './types';

function dualReceiptResultPageDefinition<T extends DocumentDualReceiptEntity>(
  type: T['type'],
  name: string
): OcrResultPageDefinition<T> {
  return {
    name: name,
    tabs: [
      {
        csvColumns: {},
        tableColumns: [],
        tableExpandable: {
          expandedRowRender: expandDualReceiptTable,
        },
      },
    ],
    formComponent: DualReceiptFormComponent,
    formDataToEntity: createFormDataToEntity(type),
    csvDataConverters: [
      {
        converter: convertDualReceiptCsv,
      },
    ],
  };
}

export const dualHorizontalReceiptResultPageDefinition =
  dualReceiptResultPageDefinition<DocumentDualHorizontalReceiptEntity>(
    'dual_horizontal_receipt',
    ocrTypeNameDefinitions.dual_horizontal_receipt
  );

export const dualVerticalReceiptResultPageDefinition =
  dualReceiptResultPageDefinition<DocumentDualVerticalReceiptEntity>(
    'dual_vertical_receipt',
    ocrTypeNameDefinitions.dual_vertical_receipt
  );
